export const MIN_SEARCH_LEN = 3;
export const ENTER_KEY = 'Enter';
export const TYPE_SEARCH = {RESULT: 'RESULT', INDT: 'INDT', GUIDELINES: 'GUIDELINES', AGENT: 'AGENT', DCI: 'DCI', DRUG: 'DRUG'};